module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "draw-signature-modal",
    on: {
      "click": _vm.handleCancel
    }
  }, [_c('div', {
    staticClass: "modal-content",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "canvas-wrapper"
  }, [_c('canvas', {
    ref: "canvas"
  })]), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('button', {
    staticClass: "btn-cancel",
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn-confirm",
    class: {
      'btn-disabled': !_vm.hasDrawn
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("确认")])])])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fa2dd0b6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fa2dd0b6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Activity/DrawSignatureModal.vue
// module id = 896
// module chunks = 0